import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

// Must match MESSAGE_MAX_LEN in backend/friends.py.
export const FRIEND_MESSAGE_MAX_LEN = 500;

// Fired after anything that changes friends or unread counts, so the
// header badge refreshes straight away instead of on its next poll.
export const FRIENDS_CHANGED_EVENT = "jangle:friends-changed";

export function friendsChanged() {
  window.dispatchEvent(new Event(FRIENDS_CHANGED_EVENT));
}

/** Unread friend messages + friend requests waiting, polled for the header. */
export function useFriendBadge(enabled) {
  const [badge, setBadge] = useState({ unread: 0, requests: 0 });

  const load = useCallback(async () => {
    if (!enabled || document.visibilityState === "hidden") return;
    try {
      const { data } = await api.get("/friends/badge");
      setBadge({ unread: data.unread || 0, requests: data.requests || 0 });
    } catch { /* keep the last count */ }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return undefined;
    load();
    const t = setInterval(load, 30000);
    window.addEventListener(FRIENDS_CHANGED_EVENT, load);
    window.addEventListener("focus", load);
    document.addEventListener("visibilitychange", load);
    return () => {
      clearInterval(t);
      window.removeEventListener(FRIENDS_CHANGED_EVENT, load);
      window.removeEventListener("focus", load);
      document.removeEventListener("visibilitychange", load);
    };
  }, [enabled, load]);

  return badge;
}
